import { Stack, Typography } from "@mui/material";
import Option from "./components/Option";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface EdProduct {
  name: string;
  medication: string;
  tags: string[];
  mobileTags?: string[];
  tagBorder: string;
  value: string;
  medicationValue: string;
  preferred?: boolean;
}

const products: EdProduct[] = [
  {
    name: "ed-options.boss-max.name",
    medication: "ed-options.boss-max.medication",
    tags: ["ed-options.boss-max.tag.0"],
    tagBorder: "linear-gradient(135deg, #219C9E 0%, #0C3838 100%)",
    value: "Boss Max",
    medicationValue: "Sildenafil + Tadalafil",
    preferred: true,
  },
  {
    name: "ed-options.boss+.name",
    medication: "payment-information.ed-ot-boss+.sildenafil.text",
    tags: [
      "ed-options.boss+.sildenafil.tag.0",
      "ed-options.boss+.sildenafil.tag.1",
      "ed-options.boss+.sildenafil.tag.2",
    ],
    mobileTags: [
      "ed-options.boss+.sildenafil.tag.0",
      "ed-options.boss+.sildenafil.tag.1",
    ],
    tagBorder: "linear-gradient(135deg, #FF8175 0%, #CCB1B1 100%)",
    value: "Boss+(Sildenafil)",
    medicationValue: "Sildenafil",
  },
  {
    name: "ed-options.boss+.name",
    medication: "payment-information.ed-ot-boss+.tadalafil.text",
    tags: [
      "ed-options.boss+.tadalafil.tag.0",
      "ed-options.boss+.tadalafil.tag.1",
      "ed-options.boss+.tadalafil.tag.2",
    ],
    mobileTags: [
      "ed-options.boss+.tadalafil.tag.0",
      // "ed-options.boss+.tadalafil.tag.1",
      "ed-options.boss+.tadalafil.tag.2",
    ],
    tagBorder: "linear-gradient(135deg, #267677 0%, #4A41EA 100%)",
    value: "Boss+(Tadalafil)",
    medicationValue: "Tadalafil",
  },
];

const EdOptions = () => {
  const { t } = useTranslation();
  const page = "ed-options";

  const preferredOption = useMemo(() => products.find((p) => p.preferred), []);
  const otherOptions = useMemo(() => products.filter((p) => !p.preferred), []);

  return (
    <Stack gap={3}>
      <Option product={preferredOption!} />
      <Typography variant="h4" textAlign={"center"} fontWeight={600}>
        {t(`${page}.other-options`, "Your other options")}
      </Typography>
      {otherOptions.map((product, idx) => (
        <Option product={product} key={idx} />
      ))}
    </Stack>
  );
};

export default EdOptions;
